import { render, staticRenderFns } from "./MdtCheckbox.vue?vue&type=template&id=12e93fe2&scoped=true"
import script from "./MdtCheckbox.vue?vue&type=script&lang=js"
export * from "./MdtCheckbox.vue?vue&type=script&lang=js"
import style0 from "./MdtCheckbox.vue?vue&type=style&index=0&id=12e93fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e93fe2",
  null
  
)

export default component.exports